module.exports = __webpack_public_path__ + "static/media/ebuilt-thank-you.a72194de.svg";